import CardDropdown from 'components/common/CardDropdown';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import CreateSponsorNav from './create-sponsor-components/CreateSponsorNav';
import DatePicker from 'react-datepicker';
import ReactSelect from 'react-select';
import Avatar from 'components/common/Avatar';
import { weUserImage2 } from 'data/weraise-data/donar-data';
import SelectBeneficiaryModal from './modals/SelectBeneficiaryModal';

const commitmentOptions = [
  { label: 'Fixed Term , open ended', value: 1 },
  { label: 'open ended', value: 2 },
  { label: 'Fixed Term', value: 3 }
];

const durationOptions = [
  { label: '6 Months', value: '6 Months' },
  { label: '9 Months', value: '9 Months' },
  { label: '12 Months', value: '12 Months' },
  { label: '18 Months', value: '18 Months' },
  { label: '24 Months', value: '24 Months' },
  { label: '36 Months', value: '36 Months' }
];

const themeOptions = [
  { label: 'Dark', value: 'dark' },
  { label: 'Light', value: 'light' },
  { label: 'System', value: 'system' }
];
const stipulationOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' }
];

const CreateNewSponsorFrom = () => {
  const [modalShow, setModalShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [startDate, setStartDate] = useState();
  const [commitment, setCommitment] = useState();
  const [duration, setDuration] = useState();
  const [theme, setTheme] = useState();
  const [stipulation, setStipulation] = useState();

  const navigate = useNavigate();
  const { id, sponsorId } = useParams();

  console.log(id);
  console.log(sponsorId);

  const handleSubmit = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };
  return (
    <>
      <div className="py-0">
        <Row className="g-3">
          <Col md={4} lg={3}>
            <CreateSponsorNav />
          </Col>
          <Col md={8} lg={9}>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Card className="mb-3">
                <FalconCardHeader
                  title={
                    <Flex>
                      <IconButton
                        variant="default"
                        className="shadow-none text-primary p-0"
                        iconClassName={'me-3'}
                        icon={'arrow-left'}
                        onClick={() => navigate(-1)}
                      />
                      <h4 className="mt-2 fw-bold fs-0  fs-md-2">
                        {sponsorId ? 'Update' : 'Create'} Sponsorship
                      </h4>
                    </Flex>
                  }
                  light={false}
                  titleTag="div"
                  menuClassName="align-items-center"
                  endEl={
                    <Flex alignItems={'center'}>
                      <Button
                        // type="submit"
                        transform="shrink-3"
                        className="me-2"
                        onClick={() => navigate(`/donors/${id}/sponsorships`)}
                      >
                        {sponsorId ? 'Update' : 'Save'}
                      </Button>
                      <CardDropdown />
                    </Flex>
                  }
                />
              </Card>

              <Card>
                <Card.Body>
                  <Row>
                    <Form.Group as={Col} md={4} className="mb-3">
                      <Form.Label>
                        Begin on <span className="text-danger">*</span>
                      </Form.Label>
                      <DatePicker
                        required
                        selected={startDate}
                        onChange={date => setStartDate(date)}
                        className="form-control"
                        placeholderText="DD/MM/YYYY"
                        timeIntervals={5}
                        dateFormat="dd/MM/yyyy"
                        showTimeSelect={false}
                        fixedHeight
                      />
                    </Form.Group>
                    <Col md={8} className="d-none d-md-block" />
                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>
                        Commitment Type <span className="text-danger">*</span>
                      </Form.Label>
                      <ReactSelect
                        required
                        closeMenuOnSelect={true}
                        options={commitmentOptions}
                        placeholder="Select"
                        classNamePrefix="react-select"
                        value={commitment}
                        onChange={value => setCommitment(value)}
                        menuPosition="fixed"
                      />
                      <Form.Control.Feedback type="invalid">
                        Required
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Col md={12} className="d-none d-md-block" />
                    <Form.Group as={Col} md={6}>
                      <Form.Label>
                        Sponsorship Duration
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <ReactSelect
                        closeMenuOnSelect={true}
                        options={durationOptions}
                        placeholder="Select"
                        classNamePrefix="react-select"
                        value={duration}
                        onChange={value => setDuration(value)}
                        menuPosition="fixed"
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Required
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Col
                      md={6}
                      className="d-flex justify-content-start justify-content-md-end align-items-end"
                    >
                      <p className="mb-0 mt-3 mt-md-0">
                        Due for renewal on : 12/2023
                      </p>
                    </Col>
                    <Col md={12} className="mt-3">
                      <div className="border rounded-3 p-3">
                        <Flex justifyContent={'between'} alignItems="center">
                          <Flex alignItems={'center'}>
                            <div className="me-3">
                              <Avatar src={weUserImage2} size="2xl" />
                            </div>
                            <p className="mb-0 fw-medium">
                              Zahran Amir Bassam - 12 Years old - Male - Jordan
                            </p>
                          </Flex>
                          <Button
                            variant="default"
                            className="text-primary shadow-none p-0"
                            onClick={() => setModalShow(true)}
                          >
                            Change
                          </Button>
                        </Flex>
                      </div>
                      <hr />
                    </Col>
                    <Form.Group as={Col} md={6} className="mb-3">
                      <Form.Label>Theme</Form.Label>
                      <ReactSelect
                        closeMenuOnSelect={true}
                        options={themeOptions}
                        placeholder="Select"
                        classNamePrefix="react-select"
                        value={theme}
                        onChange={value => setTheme(value)}
                        menuPosition="fixed"
                      />
                    </Form.Group>
                    <Col md={12} className="d-none d-md-block" />
                    <Form.Group as={Col} md={6}>
                      <Form.Label>Stipulation</Form.Label>
                      <ReactSelect
                        closeMenuOnSelect={true}
                        options={stipulationOptions}
                        placeholder="Select"
                        classNamePrefix="react-select"
                        value={stipulation}
                        onChange={value => setStipulation(value)}
                        menuPosition="fixed"
                      />
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card>
            </Form>
          </Col>
        </Row>
      </div>
      <SelectBeneficiaryModal
        setModalShow={setModalShow}
        modalShow={modalShow}
        path="#"
      />
    </>
  );
};

export default CreateNewSponsorFrom;
